import { StarIcon } from '@c/icons';
import { useQuery } from '@tanstack/react-query';
import Avatar from '@ui/Avatar';
import { getUserDocument } from '@util/firestore/users';
import { ReviewDocument } from '@util/types/firestore/review';
import Link from 'next/link';

const ReviewCard = ({ review }: { review: ReviewDocument }) => {
  const { data: user } = useQuery(
    ['user', review.reviewer_id],
    () => getUserDocument({ uid: review.reviewer_id }),
    {
      enabled: !!review.uid,
    }
  );
  const { data: seller } = useQuery(
    ['user', review.uid],
    () => getUserDocument({ uid: review.uid }),
    {
      enabled: !!review.uid,
    }
  );

  return (
    <div className="flex h-[21.2rem] w-[calc(100vw_-_1rem)] flex-col gap-[1.6rem] rounded-[10px] border-[1px] border-brand-lighter-gray p-[1.6rem] sm:w-[28.8rem]">
      <div className="flex h-touch gap-[0.8rem]">
        {user && <Avatar user={user} size="small" />}
        <div className="flex flex-col justify-between">
          <p className="text-[1.5rem] font-semibold">{user?.username}</p>
          <div className="flex gap-[0.4rem]">
            {/* render a star icon for the value of the rating. review.rating === 1 means render 1 star */}
            {[...Array(review.rating)].map((_, index) => (
              <StarIcon key={index} />
            ))}
          </div>
        </div>
      </div>
      <p className="grow text-[1.5rem] ">
        {review.comment?.slice(0, 100)}
        {review.comment && review.comment.length > 100 && (
          <Link
            href={`/shop-seller/${seller?.username_slug}`}
            className="font-semibold text-brand-secondary"
          >
            ...Read more
          </Link>
        )}
      </p>
      <div className="flex grow justify-end">
        {review.created_at &&
          // format the date to be more readable
          new Date(review.created_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
      </div>
    </div>
  );
};

export default ReviewCard;
